import type { AppRouter } from '@figmotion/authentication-api/types/router';
import { TRPCClientError } from '@trpc/client';

export function isTRPCAuthError(
  err: unknown | TRPCClientError<AppRouter>,
): err is TRPCClientError<AppRouter> {
  return Boolean(err && err instanceof TRPCClientError);
}
